// Shared degraded-state banner for portal sections. A failed section read
// renders this, never empty/settled copy (repo rule: failed seed reads are
// unknown, not empty). Moved out of ParentLayout.jsx in the #414 rider work;
// ParentLayout re-exports it so existing importers (TaLayout) are unchanged.
import { isPortalRateLimited } from './rateLimited'

export default function PortalSectionDegradedBanner({ error, t }) {
  if (!error) return null

  // #366: a throttled read is temporary, not a failure of the data itself.
  if (isPortalRateLimited(error)) {
    return (
      <div className="portal-degraded-banner" role="status">
        <div className="portal-degraded-banner-title">{t('rateLimitedTitle')}</div>
        <div className="portal-degraded-banner-body">{t('rateLimited')}</div>
      </div>
    )
  }

  return (
    <div className="portal-degraded-banner" role="alert">
      <div className="portal-degraded-banner-title">{t('dataUnavailableTitle')}</div>
      <div className="portal-degraded-banner-body">{t('dataUnavailableBody')}</div>
      <div className="portal-degraded-banner-detail">{String(error)}</div>
    </div>
  )
}
